module.exports = __webpack_public_path__ + "static/media/title_mea.e14b1b47.png";